// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a4bd8218","513":"1e7aee44","703":"6ac1a58d","787":"a334287c"}[chunkId] + ".chunk.js";
};